import { createColumnHelper } from "@tanstack/react-table";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import Select from "react-select";
import DataTable from "../../../components/dataTable/DataTable";
import { ApiEndpoints, reqGetNew } from "../../../config/apiClient";

export default function ComunicadosPage() {
    useEffect(() => {
        document.title = "Comunicados | OB PORTUS";
        listarRegistros();
        // eslint-disable-next-line
    }, []);
    const optionsSituacao: any[] = [
        {
            value: `2`,
            label: `Todos`,
        },
        {
            value: `1`,
            label: `Ativo`,
        },
        {
            value: `0`,
            label: `Inativo`,
        },
    ];
    const [loading, setLoading] = useState<boolean>(false);
    const [situacaoFiltro, setSituacaoFiltro] = useState<any>({
        value: `2`,
        label: `Todos`,
    });
    const [dados, setDados] = useState<any[]>([]);
    const [dadosView, setDadosView] = useState<any[]>([]);

    async function listarRegistros() {
        setLoading(true);
        const api = await reqGetNew(ApiEndpoints.comunicadosTodos);
        if (api.status === 200) {
            setDados(api.data);
            setDadosView(api.data);
        }
        setLoading(false);
    }

    function tableMiddleClickhandler(event: any) {
        const idx = Number(event.target.parentElement.getAttribute("about"));
        const reg: any = dadosView[idx];
        const link = `/comunicado/editar?id=${reg.id_comunicado}`;
        if (event.button === 1) {
            window.open(link);
        }
    }
    function tableClickhandler(event: any) {
        const idx = Number(event.target.parentElement.getAttribute("about"));
        const reg: any = dadosView[idx];
        const link = `/comunicado/editar?id=${reg.id_comunicado}`;
        if (event.button === 0) {
            window.location.assign(link);
        }
    }

    function handleChangeSituacao(choice: any) {
        setSituacaoFiltro(choice);
        const situacao = Number(choice.value);
        let dadosAux: any[] = [];
        for (let reg of dados) {
            switch (reg.situacao) {
                case 1:
                    if (situacao === 1 || situacao === 2) {
                        dadosAux.push(reg);
                    }
                    break;
                case 0:
                    if (situacao === 0 || situacao === 2) {
                        dadosAux.push(reg);
                    }
                    break;
            }
        }
        setDadosView(dadosAux);
    }

    return (
        <div id="main">
            <div className="div-row-space-between">
                <div className="div-row">
                    <h1 id="titleMain" style={{marginRight: "10px"}}>Comunicados</h1>
                    <Select
                        name="ids_inativado"
                        id="ids_inativado"
                        options={optionsSituacao}
                        defaultValue={situacaoFiltro}
                        value={situacaoFiltro}
                        placeholder="Situação"
                        onChange={(choice: any) => {
                            handleChangeSituacao(choice);
                        }}
                        styles={styleFiltroPequeno}
                    />
                </div>
                <div className="div-row">
                    <Button
                        onClick={() => {
                            window.location.assign(`/comunicado/cadastrar`);
                        }}
                    >
                        Cadastrar
                    </Button>
                </div>
            </div>
            <br></br>
            {loading && <Spinner />}
            {!loading && <DataTable dados={dadosView} tableSize={"auto"} defaultColumns={defaultColumns} tableMiddleClickhandler={tableMiddleClickhandler} tableClickhandler={tableClickhandler} defaultOrder={defaultOrder} defaultRows={23} />}
        </div>
    );
}
const columnHelper = createColumnHelper<any>();
const defaultColumns = [
    columnHelper.accessor((row) => row.id_comunicado, {
        header: "ID",
        size: 50,
    }),
    columnHelper.accessor((row) => `${dayjs(row.data_criacao).format("DD/MM/YYYY HH:mm:ss")}`, {
        header: "Criado em",
    }),
    columnHelper.accessor((row) => row.titulo, {
        header: "Título",
        size: 250,
    }),
    columnHelper.accessor((row) => (row.data_alteracao === null ? "" : `${dayjs(row.data_alteracao).format("DD/MM/YYYY HH:mm:ss")}`), {
        header: "Data Alteração",
    }),
    columnHelper.accessor((row) => (row.data_inicial === null ? "" : `${dayjs(row.data_inicial).format("DD/MM/YYYY HH:mm:ss")}`), {
        header: "Data Inicial",
    }),
    columnHelper.accessor((row) => (row.data_final === null ? "" : `${dayjs(row.data_final).format("DD/MM/YYYY HH:mm:ss")}`), {
        header: "Data Final",
    }),
    columnHelper.accessor((row) => (row.situacao === 1 ? "Ativo" : "Inativo"), {
        header: "Situação",
        size: 100,
    }),
];
const defaultOrder: any[] = [];

const styleFiltroPequeno = {
    control: (baseStyles: any, state: any) => ({
        ...baseStyles,
        width: "250px",
        borderColor: "#dee2e6",
        minHeight: "39px",
        maxHeight: "120px",
        marginRight: "5px",
        fontSize: "14px",
    }),
    valueContainer: (provided: any, state: any) => ({
        ...provided,
        minHeight: "30px",
        maxHeight: "120px",
        overflowY: "auto",
        fontSize: "14px",
    }),
    input: (provided: any, state: any) => ({
        ...provided,
        margin: "0px",
        fontSize: "14px",
    }),
    indicatorSeparator: (state: any) => ({
        display: "none",
        fontSize: "14px",
    }),
    indicatorsContainer: (provided: any, state: any) => ({
        ...provided,
        minHeight: "39px",
        maxHeight: "120px",
        fontSize: "14px",
    }),
    menu: (provided: any, state: any) => ({
        ...provided,
        fontSize: "14px",
    }),
};
